import { IntlProvider, MessageFormatElement } from 'react-intl';

import React from 'react';
import { useAppSelector } from '../core/hooks';
import { localeSelector } from '../stores/userPreferences';
interface I18nInput {
  children: React.ReactNode;
  messages: Record<string, string> | Record<string, MessageFormatElement[]> | undefined;
}

const BaseMessageProvider = ({ children, messages }: I18nInput) => {
  const locale = useAppSelector(localeSelector);

  return (
    <IntlProvider locale={locale} messages={messages} defaultLocale='pt'>
      {children}
    </IntlProvider>
  );
};

export default BaseMessageProvider;
